import { Alert, cn, Spinner, Typography } from '@prenuvo/halo-foundation';

import { FCT } from '@/i18n';

import { useReportIssue } from '../use-report-issue.hook';
import { ReportDescriptionGuide, ReportFormActions, ReportFormFields } from './report-form';
import { ReportIssueModal } from './report-issue-modal.component';
import { useReportIssueHandler } from './use-report-issue-handler.hook';

export function ReportIssueHandlerContent() {
  const { onToggleReportIssue, showReportIssue } = useReportIssue();

  const {
    isReportIssueError,
    isReportIssuePending,
    isReportIssueSuccess,
    isReportServiceDeskIssueError,
    isReportServiceDeskIssuePending,
    isReportServiceDeskIssueSuccess,
  } = useReportIssueHandler();

  const isSuccess = isReportIssueSuccess || isReportServiceDeskIssueSuccess;
  const isError = isReportIssueError || isReportServiceDeskIssueError;

  return (
    <ReportIssueModal
      onOpenChange={onToggleReportIssue}
      open={showReportIssue}
      title={isSuccess ? '' : FCT.REPORTING.REPORT_ISSUE.TITLE}
    >
      {isReportIssuePending || isReportServiceDeskIssuePending ? (
        <div className="flex h-[510px] items-center justify-center">
          <Spinner size="sm" variant="white" />
        </div>
      ) : (
        <div
          className={cn('space-y-4', {
            'mt-[-32px]': isSuccess,
          })}
          data-testid="report-issue-form"
        >
          {isSuccess ? (
            <Typography className="text-center" variant="paragraph-md">
              {FCT.REPORTING.REPORT_ISSUE.SUCCESS}
            </Typography>
          ) : (
            <>
              {isError && (
                <Alert
                  className={{
                    description: 'px-2',
                    root: 'm-0',
                    title: 'px-2',
                  }}
                  description={FCT.REPORTING.REPORT_ISSUE.ERROR.DESCRIPTION}
                  title={FCT.REPORTING.REPORT_ISSUE.ERROR.TITLE}
                  variant="error"
                />
              )}
              <ReportFormFields />
              <ReportDescriptionGuide />
            </>
          )}
          <ReportFormActions />
        </div>
      )}
    </ReportIssueModal>
  );
}
